module.exports = __webpack_public_path__ + "img/setting0.8148cbd0.jpg";